export default function (widgetNameVariable, widgetOption) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOption;
  let swiperImages;
  let swiperContent;

  const wrapContainerClass = 'multi-slider-container';

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="swiper-pagination"></div>

      <div class="arrows-container">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    

    <div class="content-wrapper">
        <div class="swiper-container swiper-container-content">
          <div class="swiper-wrapper"></div>
        </div>     
    </div>
  `;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const title = `<h2 class="slide-title">${slide.Title}</h2>`;
    const description = slide.Description
      ? `<p class="slide-description${!slide.URL ? ' no-mgt' : ''}">${slide.Description}</p>`
      : '';

    const buttons = function (btn2) {
      if (btn2) {
        let btnContainer = $(
          `<div class="button-container"><a href="${btn2}" class="button">Learn More</a></div>`,
        );

        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class='swiper-content-container'>
        <div class='slide-content'>
          <div class="slide-title-container">
          ${title}
          </div>
          ${description}
          </div>
          ${buttons(slide.URL)}
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

    swiperImages = swiperWidgetImages;
    swiperContent = swiperWidgetContent;

    // Observer to stop autoplay when user is not looking at the slider
    const sliderToObserve = document.querySelector(`#${widgetName} .swiper-container`);

    if (sliderToObserve) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiperWidgetImages.autoplay.start();
            } else {
              swiperWidgetImages.autoplay.stop();
            }
          });
        },
        { threshold: 0.1 },
      );

      observer.observe(sliderToObserve);
    }
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      wrapAllSliders(widgetName, wrapContainerClass);
      updateSwiper(swiperImages, swiperContent);
    } else {
      $(`#${widgetName}`).remove();
    }
  });
}

function wrapAllSliders(widgetName, wrapContainerClass) {
  let dataName = $(`#${widgetName}`).parent().parent().attr('class');
  if (dataName !== wrapContainerClass) {
    $('.slideshow-gallery')
      .wrapAll(`<div class="${wrapContainerClass}"></div>`)
      .wrapAll('<div class="inner-container"></div>');
  }
}

function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}
